import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Button} from 'shared/components';
import {types} from 'main/tools';

const ApplyShift = observer(({model, uiState}) => {
  if (model._type === types.TIME_OFF.ABSENCE || model._type === types.HOLIDAY) return null;

  const shift = uiState.shiftFor(model);
  if (!shift) return null;

  if (uiState.canApplyShift(model)) {
    return (
      <div>
        <div className='jumbo pb1'>{shift.timeRange}</div>
        <Button trait='default' size='sm' onClick={() => uiState.applyShift(model)}>
          <FormattedMessage id='time_tracking.timesheet.Apply Shift'/>
        </Button>
      </div>
    );
  }

  return <div className='jumbo'>{shift.timeRange}</div>;
});

export default ApplyShift;
